<template>
  <div class="home">
    <Header @sendMessage="sendMessage($event)"/>
    <Intro v-scroll-reveal="{ delay: 250 }" />
    <Section :content="getContent('scanning')" v-scroll-reveal="{ delay: 250 }" @sendMessage="sendMessage($event)"/>
    <Section :content="getContent('managing')" v-scroll-reveal="{ delay: 250 }" @sendMessage="sendMessage($event)"/>
    <Section :content="getContent('automating')" v-scroll-reveal="{ delay: 250 }" @sendMessage="sendMessage($event)"/>
    <Ebook v-scroll-reveal="{ delay: 250 }" />
    <FAQ v-scroll-reveal="{ delay: 250 }" />

    <Footer />  
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Intro from '@/components/Intro.vue'
import Section from '@/components/Section.vue'
import Ebook from '@/components/Ebook.vue'
import FAQ from '@/components/FAQ.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'home',
  components: {
    Header,
    Intro,
    Section,
    FAQ,
    Ebook,
    Footer
  },
  data() {
    return {
      services: [
        {
            title: `Numérisation de documents`,
            icon: `archive`,
            subtitle: `Le premier pas vers une saine gestion documentaire`,
            name: `Numériser`,
            section: `scanning`,
            img: require('@/assets/svg/cabinet.svg'),
            text: [
              `Il peut être parfois difficile d'abandonner le papier ainsi que le sentiment de sécurité qu'il nous procure.
              Toutefois, beaucoup reconnaissent que le papier est en perte de vitesse, que l’ère du document électronique
              est à nos portes et que le temps est venu d’adopter les technologies qui favorisent ce passage.`,
              `Les entreprises qui ont franchis cette étape vous confirmeront que l'adoption d'une gestion 
              électronique des documents leur a permis de gagner significativement en efficacité.`,
              `Faire appel à notre équipe de numérisation professionnelle vous permettra d’entreprendre la numérisation 
              de vos documents avec confiance, efficacité et dans le respect du cadre réglementaire et légal régissant ceux-ci.`
            ],
            cta: [
              {
                name: `quotation`,
                text: `Obtenez un devis`,
                action: `sendMessage`
              }
            ]
        },
        {
            title: `Gestion électronique des documents`,
            icon: `cloud-upload-alt`,
            subtitle: `Mieux organiser vos documents et vos données`,
            name: `Organiser`,
            section: `managing`,
            img: require('@/assets/svg/ECM.svg'),
            text: [
              `Opter pour une gestion électronique des documents, c'est permettre aux données critiques d'une organisation d'être 
              facilement accessibles et de pouvoir être échangées plus rapidement en toute transparence.`,
              `C'est opter pour une plus grande sécurité en ayant la possibilité d'exercer un contrôle plus rigoureur.`,
              `En plus de gagner en efficacité, d'augmenter leur productivité, de réduire leur coût d'opération et de renforcer 
              leur sécurité, les entreprises qui mettent en place une gestion électronique de leurs documents réduisent aussi leurs
              empreinte environnementale.`
            ],
            cta: [
              {
                name: `consulting`,
                text: `Consultez un expert`,
                action: [`sendMessage`]
              }
            ]
        },
        {
            title: `Automatisation de processus d'affaires`,
            icon: `sitemap`,
            subtitle: `Accélérer tout en gagnant en efficacité`,
            name: `Automatiser`,
            section: `automating`,
            img: require('@/assets/svg/robot.svg'),
            text: [
              `Opter pour une gestion électronique de documents ouvre la porte à de nouvelles possibilités 
              telles que l'automatisation des tâches routinières et répétitives qui encombrent votre 
              personnel au quotidien.`,
              `Saisie de données, classement de documents, approbation, notifications, rappels, suivis, 
              etc.  Nos spécialistes sont en mesure de vous diriger vers des outils qui vous permettront 
              d'optimiser les performances de votre entreprise.`,
              `Consulter un expert de La Cartoucherie vous permettra de faire un choix éclairé et d'optimiser 
              le retour sur investissement lors du déploiement de votre solution.`
            ],
            cta: [
              {
                name: `blog`,
                text: `Apprenez-en davantage`,
                link: { name: `blog` },
              }
            ]
        }
      ]
    }
  },
  methods: {
    sendMessage(subject) {
      console.log(subject)
      this.$emit('sendMessage', subject)
    },
    getContent(section) {
      let c = this.services.filter( function (el) {
        return el.section === section
      })

      return c
    }
  }
}
</script>

<style scoped>
</style>
